<template>
    <el-dialog visible width="98%" append-to-body class="roleAdd_moda" @close="onCancel">
        <label slot="title" class="tip">
            <span class="moda-title">{{ $t('PAGE_CLIENTROLES_TITLE') }}</span>
        </label>
        <div class="tip">
            <i class="el-icon-warning" style="color: #fd349c"></i>&nbsp;&nbsp;
            <span style="font-size:12PX;color:#fd349c;">{{ $t('CLIENT_ROLE_MSG') }}</span>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :inline="true" class="demo-ruleForm">
            <el-form-item style="width: 35%" :label="$t('TABLE_HEADER_roleName')" prop="roleName">
                <el-input v-model="ruleForm.roleName" maxlength="100" class="input-with-select"></el-input>
            </el-form-item>
            <el-form-item style="width: 40%" :label="$t('FORM_LABEL_description')" prop="description">
                <el-input style="width: 400px" v-model="ruleForm.description" maxlength="100" class="input-with-select"></el-input>
            </el-form-item>
            <el-button type="primary" :loading="saveLoading" @click="onConfirm" style="float: right" class="wl-green">{{
                $t('btn_save')
            }}</el-button>
        </el-form>
        <el-row>
            <p class="title">{{ $t('PAGE_CLIENTROLES_PERMISSION') }}&nbsp;&nbsp;</p>
        </el-row>

        <div class="step">
            <!--      步骤条-->
            <div>
                <el-steps :active="activeStep" finish-status="success" align-center>
                    <el-step :title="$t('CLIENTROLE_ADD_STEP1')" class="step-des"></el-step>
                    <el-step :title="$t('CLIENTROLE_ADD_STEP2')" class="step-des"></el-step>
                    <el-step :title="$t('CLIENTROLE_ADD_STEP3')" class="step-des"></el-step>
                    <el-step :title="$t('CLIENTROLE_ADD_STEP4')" class="step-des"></el-step>
                </el-steps>
            </div>
            <div class="step-content">
                <div class="part-entity">
                    <div class="box-item">
                        <p class="item-title entity">{{ $t('COMMON_ENTITY') }}</p>
                        <div class="item-content with-select-all-tree-clientRoles">
                            <el-input
                                :placeholder="$t('ENTER_SEARCH_CONTENT')"
                                style="padding: 5px 20px 5px 5px; font-size: 12PX"
                                v-model="filterText"
                            />
                            <el-tree
                                :default-expand-all="true"
                                :check-strictly="true"
                                :expand-on-click-node="false"
                                :data="data"
                                :props="defaultProps"
                                :default-checked-keys="entityTreeCheckedList"
                                node-key="key"
                                show-checkbox
                                :render-content="renderContent"
                                :filter-node-method="filterNode"
                                @check="handleCheckChange"
                                ref="tree"
                            >
                                <span slot-scope="{ node, data }">
                                    <span :title="node.label">{{ node.label }}</span>
                                </span>
                            </el-tree>
                        </div>
                    </div>
                </div>
                <!-- 板块 -->
                <div class="part-tile" v-if="activeStep > 0">
                    <div class="box-item">
                        <div class="item-title title-select-content">
                            <p class="entity">{{ $t('COMMON_TILES') }}</p>
                            <p v-if="!isSelectAll(titleForm.configList)" class="select-cls" @click="checkedTile(true)">
                                {{ $t('select_all') }}
                            </p>
                            <p v-else class="select-cls" @click="checkedTile(false)">{{ $t('unselect_all') }}</p>
                        </div>
                        <div class="item-content">
                            <el-form :model="titleForm" ref="titleForm" class="titleForm">
                                <el-form-item
                                    v-for="(item, index) in titleForm.configList"
                                    class="title-form-item"
                                    style="margin-bottom: 0"
                                    :key="index"
                                    :prop="item.menuCode"
                                >
                                     <el-checkbox v-if="item.menuCode == 'client006'" v-model="item.checked" @change="tileCheck(item)">{{
                                        $t('ROLE_' + item.menuCode)
                                    }}</el-checkbox>
                                  <!--  <el-checkbox v-else v-model="item.checked" @change="tileCheck(item)">{{
                                        $t('ROLE_' + item.menuCode)
                                    }}</el-checkbox> -->

                                    <el-checkbox class="set-disabled" v-else v-model="item.checked" :disabled="item.menuCode === 'client004'" @change="tileCheck(item)">
                                        {{ $t('ROLE_' + item.menuCode) }}
                                        <span v-show="item.menuCode === 'client004'">（{{ $t('required') }}）</span>
                                    </el-checkbox>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
                <div class="part-pbcOrCategory" v-if="activeStep > 1">
                    <div class="box-item" v-if="pbcShow" style="margin-bottom: 10px">
                        <p class="item-title">
                            <span style="color:#fd349c; font-size: 13px">*</span>
                            {{ $t('COMMON_PBC_TITLE_LIST') }}
                        </p>
                        <!-- 年终 -->
                        <div class="item-content">
                            <el-collapse v-model="FINAL" class="item-collapse">
                                <el-collapse-item name="FINAL">
                                    <template slot="title"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('COMMON_FINAL') }} </template>
                                    <div v-if="pbcFinalForm.final.length > 0" class="pbc-selectAll-cls select-cls">
                                        <span v-if="!isSelectAll(pbcFinalForm.final)" @click="pbcCheck(pbcFinalForm.final, true)">{{
                                            $t('select_all')
                                        }}</span>
                                        <span v-else @click="pbcCheck(pbcFinalForm.final, false)">{{ $t('unselect_all') }}</span>
                                    </div>
                                    <el-form :model="pbcFinalForm" ref="pbcFinalForm" class="pbcFinalForm">
                                        <el-form-item v-for="item in pbcFinalForm.final" :key="item.id" :prop="item.id">
                                            <el-checkbox @change="checkBoxPbc(false, item)" v-model="item.checked">
                                                <span
                                                    :title="item.groupName + '(' + dateFormat(item.periodEndDate) + ')'"
                                                    style="font-size: 12PX"
                                                >
                                                    {{ item.groupName }}({{ item.periodEndDate | formatDate }})
                                                </span>
                                            </el-checkbox>
                                        </el-form-item>
                                    </el-form>
                                </el-collapse-item>
                            </el-collapse>
                            <!-- 中期 -->
                            <el-collapse v-model="INTERIM" class="item-collapse">
                                <el-collapse-item name="INTERIM">
                                    <template slot="title"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('COMMON_INTERIM') }} </template>
                                    <div v-if="pbcInterimForm.Interim.length > 0" class="pbc-selectAll-cls select-cls">
                                        <span v-if="!isSelectAll(pbcInterimForm.Interim)" @click="pbcCheck(pbcInterimForm.Interim, true)">{{
                                            $t('select_all')
                                        }}</span>
                                        <span v-else @click="pbcCheck(pbcInterimForm.Interim, false)">{{ $t('unselect_all') }}</span>
                                    </div>
                                    <el-form :model="pbcInterimForm" ref="pbcInterimForm" class="pbcInterimForm">
                                        <el-form-item v-for="item in pbcInterimForm.Interim" :key="item.id" :prop="item.id">
                                            <el-checkbox @change="checkBoxPbc(false, item)" v-model="item.checked">
                                                <span
                                                    :title="item.groupName + '(' + dateFormat(item.periodEndDate) + ')'"
                                                    style="font-size: 12PX"
                                                >
                                                    {{ item.groupName }}({{ item.periodEndDate | formatDate }})
                                                </span>
                                            </el-checkbox>
                                        </el-form-item>
                                    </el-form>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                    </div>
                    <div class="box-item" v-if="categoryShow">
                        <div class="item-title title-select-content">
                            <!-- B-携手共享文件夹类别 -->
                            <p class="category-title" :title="$t('PAGE_EXCHANGE_TAB1_for_clientrole')">{{ $t('ROLE_client005') }}</p>
                        </div>
                        <div class="item-content categoryForm">
                            <el-collapse v-model="EXCHANGE" class="item-collapse collapse_exchange">
                                <el-collapse-item name="EXCHANGE">
                                    <template slot="title">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('COMMON_CATEGORY_LIST') }}
                                    </template>
                                    <div class="pbc-selectAll-cls select-cls">
                                        <template v-if="categoryData.length > 0">
                                            <p v-if="!isSelectAll(categoryData)" class="select-cls" @click="checkedCategory(true)">
                                                {{ $t('select_all') }}
                                            </p>
                                            <p v-else class="select-cls" @click="checkedCategory(false)">{{ $t('unselect_all') }}</p>
                                        </template>
                                    </div>
                                    <div v-for="(item, index) in categoryData" :key="index" class="categoryItem">
                                        <el-checkbox v-model="item.checked">{{ categoryTranslate(item.category) }}</el-checkbox>
                                    </div>
                                </el-collapse-item>
                                <el-checkbox v-model="ituChecked" true-label="1" false-label="0" style="margin-left: 8PX;" class="itu-checkbox"><span class="blod" role="button">{{ $t('client_role_enable_itu') }}</span></el-checkbox>
                            </el-collapse>
                        </div>
                    </div>
                    <div class="box-item" v-if="adminShow">
                        <div class="item-title title-select-content">
                            <p class="category-title w-full" :title="$t('client008_tips')">
                                {{ $t('ROLE_client008') }}
                                <span class="role-tip">{{ $t('client008_tips') }}</span>
                            </p>
                        </div>
                        <div class="item-content categoryForm">
                            <el-collapse v-model="ADMIN" class="item-collapse collapse_exchange">
                                <el-collapse-item name="admin">
                                    <template slot="title">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('client008') }}
                                    </template>
                                    <div class="pbc-selectAll-cls select-cls">
                                        <template v-if="adminTabs.length > 0">
                                            <p v-if="!isSelectAll(adminTabs)" class="select-cls" @click="checkedAdminTab(true)">
                                                {{ $t('select_all') }}
                                            </p>
                                            <p v-else class="select-cls" @click="checkedAdminTab(false)">{{ $t('unselect_all') }}</p>
                                        </template>
                                    </div>
                                    <div v-for="(item, index) in adminTabs" :key="index" class="categoryItem" v-if="!item.disabled">
                                        <el-checkbox v-model="item.checked" >{{ item.name }}</el-checkbox>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                    </div>
                </div>
                <div class="part-detailPbc" v-if="activeStep > 2 && hasPbc ">
                    <div class="box-item">
                        <p class="item-title" style="display: flex; flex-direction: row; align-items: center">
                            <span style="color:#fd349c; font-size: 13px">*</span>
                            <el-select class="topFilter" v-model="filterValue" :placeholder="$t('PAGE_PBC_LIST_SELECT_TOPIC')">
                                <el-option
                                    v-for="item in topicListFilter"
                                    class="pbc-select-item"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </p>
                        <div class="item-content">
                            <template v-for="(item, index) in topicListFilter">
                                <div
                                    :key="index + 'btn'"
                                    v-if="item.id == filterValue"
                                    class="fourth-box-select"
                                    @click="switchTopicTreeSelect(index, item.id)"
                                >
                                    {{ isTopicTreeAllSelect ? $t('unselect_all') : $t('select_all') }}
                                </div>
                                <el-tree
                                    :key="index"
                                    v-show="item.id == filterValue"
                                    style="width: 100%"
                                    :default-expand-all="true"
                                    :expand-on-click-node="false"
                                    :data="topicTreeData"
                                    :props="topicProps"
                                    node-key="topicBindId"
                                    :default-checked-keys="topicTreeCheckedList.get(item.id)"
                                    show-checkbox
                                    @check="(a, b) => handleLastTreeCheckChange(a, b, item.id)"
                                    :ref="'topicTree' + index"
                                >
                                    <span slot-scope="{ node, data }" class="tree-node">
                                        <span class="tree-label-cls" :title="node.label">{{ node.label }}</span>
                                    </span>
                                </el-tree>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="onCancel" class="cancel-btn">{{ $t('comment_reSet') }}</el-button>
            <el-button type="primary" :loading="saveLoading" @click="onConfirm" class="wl-green">{{ $t('btn_save') }}</el-button>
        </span>
    </el-dialog>
</template>
<script>
import API from '@/api'
import { dateFormat, UserInput } from '@/utils'
import { mapGetters } from 'vuex'
import allCategory from '@/views/client-view/exchange/allCategory.js'

export default {
    data() {
        return {
            filterText: '',
            activeStep: 0,
            pbcShow: false,
            categoryShow: false,
            switchFlag: 0,
            isTopicTreeAllSelect: false,
            data: [
                {
                    id: '001',
                    siteId: '001',
                    parentKey: '',
                    entityName: 'ClientA',
                    entityDesc: 's',
                    entityType: 'root',
                    seq: '',
                    key: '001',
                    childEntity: []
                }
            ],
            defaultProps: {
                children: 'childEntity',
                label: 'entityName'
            },
            ruleForm: {
                roleName: '',
                description: ''
            },
            titleForm: {
                configList: []
            },
            pbcType: 'Interim',
            pbcFinalForm: {
                final: []
            },
            pbcInterimForm: {
                Interim: []
            },
            topicProps: {
                children: 'childTopic',
                label: 'topicName'
            },
            topicList: new Map(),
            topicListFilter: [],
            filterValue: '',
            entityTreeCheckedList: [],
            entityTreeCheckedIds: [],
            topicTreeCheckedList: new Map(),
            topicTreeCheckedListItem: [],
            FINAL: 'FINAL',
            INTERIM: 'INTERIM',
            EXCHANGE: ['EXCHANGE', 'ITU'],
            ITU: 'ITU',
            ituChecked: '0',
            timer: null,
            categoryData: [],
            categoryCheckedList: [],
            categoryLoading: false,
            allCategory: allCategory[0],
            ADMIN:['admin'],
            adminShow:false,
            adminList:[],
            adminTabs:[
                {
                    name:this.$t('admin.invoices'),
                    key:'adminInvoice',
                    checked:false
                },
                {
                    name:this.$t('admin.vat'),
                    key:'adminVatInformation',
                    checked:false,
                    disabled:false
                },
                {
                    name:this.$t('admin.contract'),
                    key:'adminContract',
                    checked:false
                },
                {
                    name:this.$t('admin.fee'),
                    key:'adminFeeAgreement',
                    checked:false
                },
            ],
        }
    },
    filters: {
        formatDate: (value) => {
            return dateFormat(new Date(value), 'yyyy-MM-dd')
        }
    },
    methods: {
        async queryShowVatInformation(){
            const {code, data} =  await API.common.queryShowVatInformation({
                    siteId: this.getSite.siteId
                })
            if(code === '1'){
                this.adminTabs.forEach(adminTab=>{
                    if(adminTab.key === 'adminVatInformation'){
                        adminTab.disabled = !data;
                    }
                })

            }
        },
        categoryTranslate(v) {
            const findCategory = this.allCategory.find(vv => vv.realValue == v)
            if (findCategory && findCategory.value) {
                return this.$t(findCategory.value)
            } else {
                return v
            }
        },
        // 当版块的选中被改变
        tileCheck(v) {
             
            /**
             * 取消勾选了pbc，那就把后面的pbc相关的全部取消勾选
             */
            if (v.menuCode == 'client001' && !v.checked) {
                // 取消所有中期
                this.pbcInterimForm.Interim.forEach(v => {
                    v.checked = false
                })
                // 取消所有年终
                this.pbcFinalForm.final.forEach(v => {
                    v.checked = false
                })
                // 取消所有pbc条目
                this.topicTreeCheckedList.forEach((v, k) => {
                    this.topicTreeCheckedList.set(k, [])
                })
            }
            /**
             * 如果取消勾选了 exchange，那就把后面携手共享的全部取消勾选
             */
             if (v.menuCode == 'client005' && !v.checked) {
                this.categoryData.forEach(v => {
                    v.checked = false
                })
                this.ituChecked = "0"
             }
             /**
             * 如果取消勾选了 admin，那就把后面admin的全部取消勾选
             */  
             if (v.menuCode == 'client008' && !v.checked) {
                this.checkedAdminTab(false)
             }
            this.checkBoxPbc()

        },
        filterNode(value, data) {
            if (!value) return true
            return data.entityName.toLowerCase().indexOf(value.toLowerCase()) !== -1
        },
        // 判断是否全选
        isSelectAll(list) {
            return list.every((item) => item.checked)
        },
        // tile全选/全不选
        checkedTile(isChecked) {
            if (isChecked) {
                this.activeStep = 2
                this.pbcShow = true
                this.categoryShow = this.titleForm.configList.some((item) => item.menuCode === 'client005')
                this.adminShow = this.titleForm.configList.some((item) => item.menuCode === 'client008')
                if (this.pbcShow) {
                    const interim = this.getCheckedPbcList(this.pbcInterimForm.Interim)
                    const final = this.getCheckedPbcList(this.pbcFinalForm.final)
                    let all = interim.concat(final) || []
                    if (all.length > 0) {
                        this.activeStep = 3
                    }
                }
            } else {
                this.activeStep = 1
                this.pbcShow = false
                this.categoryShow = false
            }
            this.titleForm.configList.forEach((item) => {
                item.checked = isChecked
                if (item.menuCode === 'client004') {
                    item.checked = true
                } else {
                    item.checked = isChecked
                }
            })
        },
        // admin tabs 全选/全不选
        checkedAdminTab(isChecked) {
            this.adminTabs.forEach((item) => (item.checked = isChecked))
        },
        // category 全选/全不选
        checkedCategory(isChecked) {
            this.categoryData.forEach((item) => (item.checked = isChecked))
        },
        pbcCheck(list, isChecked) {
            list.forEach((item) => (item.checked = isChecked))
            if (isChecked) {
                this.activeStep = 3
                this.checkBoxPbc(false, null)
            } else {
                const interim = this.getCheckedPbcList(this.pbcInterimForm.Interim)
                const final = this.getCheckedPbcList(this.pbcFinalForm.final)
                let all = interim.concat(final) || []
                if (all.length > 0) {
                    this.activeStep = 3
                } else {
                    this.activeStep = 2
                }
            }
        },
        // 判断entity选择后的activeStep的情况
        setStep() {
            this.activeStep = 0
            // entity
            const entityList = this.getCheckedTreeList(this.$refs.tree.getCheckedNodes())
            if (entityList.length > 0) {
                this.activeStep = 1
                // tiles
                const tileList = this.getMenuListChecked()
                if (tileList.length > 0) {
                    this.activeStep = 2
                    this.pbcShow = false
                    this.categoryShow = false
                    this.adminShow = false
                    tileList.forEach((item) => {
                        if (item.menuId == 14) {
                            this.pbcShow = true
                        }
                        if (item.menuId == 20) {
                            this.categoryShow = true
                        }
                    })
                    //pbc
                    const interim = this.getCheckedPbcList(this.pbcInterimForm.Interim)
                    const final = this.getCheckedPbcList(this.pbcFinalForm.final)
                    let all = interim.concat(final)
                    if (this.pbcShow && all.length > 0) {
                        this.activeStep = 3

                        if (this.topicTreeCheckedList.size > 0) {
                            let isChoose = false
                            for (let i = 0; i < all.length; i++) {
                                let len = this.topicTreeCheckedList.get(all[i]) ? this.topicTreeCheckedList.get(all[i]).length : 0
                                if (len > 0) {
                                    isChoose = true
                                    break
                                }
                            }
                            if (isChoose) this.activeStep = 4
                        }
                    }
                }
            } else {
                const tileList = this.getMenuListChecked()
                if (tileList.length > 0) {
                    this.titleForm.configList.forEach((item) => {
                        item.checked = false
                    })
                }
            }
        },
        switchTopicTreeSelect(treeIdx, id) {
            const treeData = this.topicTreeData
            const allKeys = []
            if (!treeData.length) return
            const stack = [...treeData]
            const TreeRef = this.$refs[`topicTree${treeIdx}`][0]
            while (stack.length) {
                const data = stack.pop()
                if (data.childTopic) {
                    data.childTopic.forEach((item) => {
                        stack.push(item)
                    })
                }
                allKeys.push(data.topicBindId)
                TreeRef.setChecked(data.topicBindId, !this.isTopicTreeAllSelect)
            }
            this.isTopicTreeAllSelect = !this.isTopicTreeAllSelect
            this.topicTreeCheckedList.set(id, this.isTopicTreeAllSelect ? allKeys : [])
        },
        handleLastTreeCheckChange(node, checkedInfo, id) {
            const treeData = this.topicTreeData
            if (!treeData.length) return
            const stack = [...treeData]
            let isTopicTreeAllSelect = true
            while (stack.length) {
                const data = stack.pop()
                if (data.childTopic) {
                    data.childTopic.forEach((item) => {
                        stack.push(item)
                    })
                }
                if (!checkedInfo.checkedKeys.includes(data.topicBindId)) {
                    isTopicTreeAllSelect = false
                    break
                }
            }
            this.isTopicTreeAllSelect = isTopicTreeAllSelect
            this.topicTreeCheckedList.set(id, checkedInfo.checkedKeys)
            this.setStep()
            // data.checked = !data.checked
            // this.isTopicTreeAllSelect = this.isAllSelected(this.)
        },
        isAllSelected(data) {
            const stack = [data]
            const allNodes = [data]
            let isAllSelected = true
            while (stack.length) {
                const node = stack.pop()
                if (node.childEntity) {
                    node.childEntity.forEach((item) => {
                        stack.push(item)
                        allNodes.push(item)
                    })
                }
                if (!node.checked) isAllSelected = false
            }

            return [isAllSelected, allNodes]
        },
        switchSelect(isAllSelected, allNodes) {
            // 存在过滤条件的全选/不全选
            if (this.filterText.length > 0) {
                if (allNodes.some((item) => item.entityType === 'ROOT')) {
                    let subTemp = allNodes.filter(
                        (item) => item.entityName.indexOf(this.filterText) != -1 && item.entityType === 'SUB_ENTITY'
                    )
                    let idList = []
                    subTemp.forEach((item) => {
                        idList.push(item.id)
                        idList.push(item.parentKey)
                    })
                    let entityTemp = allNodes.filter((node) => idList.indexOf(node.id) != -1 || idList.indexOf(node.key) != -1)
                    let rootTemp = allNodes.filter((item) => item.entityType === 'ROOT')
                    allNodes = entityTemp.concat(rootTemp)
                } else {
                    allNodes = allNodes.filter(
                        (item) =>
                            (item.entityName.indexOf(this.filterText) != -1 && item.entityType === 'SUB_ENTITY') ||
                            item.entityType === 'ENTITY'
                    )
                }
            }
            if (isAllSelected) {
                allNodes.forEach((item) => {
                    item.checked = false
                    this.$refs.tree.setChecked(item.key, false)
                })
                this.setStep()
            } else {
                allNodes.forEach((item) => {
                    this.$refs.tree.setChecked(item.key, true)
                    item.checked = true
                })
            }
            this.switchFlag = this.switchFlag === 0 ? 1 : 0
            this.LinkageOther()
        },
        getCheckedPbcList(arr) {
            if (arr instanceof Array) {
                const list = []
                arr.forEach((i, n) => {
                    if (i.checked) {
                        list.push(i.id)
                    }
                })
                return list
            }
        },
        getCheckedPbcListName(arr, type) {
            if (arr instanceof Array) {
                const list = []
                arr.forEach((i, n) => {
                    if (i.checked) {
                        list.push({ name: i.groupName + ' (' + this.$t(type) + ')', id: i.id })
                    }
                })
                return list
            }
        },
        getTopicList(arr) {
            this.topicList.clear()
            this.topicListFilter.forEach((i, n) => {
                const item = []
                arr.forEach((j, k) => {
                    if (i.id == j.pbcGroupId) {
                        item.push(j)
                    }
                })
                this.topicList.set(i.id, item)
            })
        },
        checkBoxPbc() {
            const inteim = this.getCheckedPbcList(this.pbcInterimForm.Interim)
            const final = this.getCheckedPbcList(this.pbcFinalForm.final)
            const list = inteim.concat(final)
            const inteimOb = this.getCheckedPbcListName(this.pbcInterimForm.Interim, 'Interim')
            const finalOb = this.getCheckedPbcListName(this.pbcFinalForm.final, 'Final')
            this.topicListFilter = inteimOb.concat(finalOb)
            this.setStep()
            if (!list.includes(this.filterValue)) {
                this.filterValue = ''
                this.isTopicTreeAllSelect = false
            }
            const params = {
                roleId: this.roleId,
                pbcIds: list
            }
            if (list.length <= 0 || this.topicListFilter.length <= 0) {
                this.filterValue = ''
                this.isTopicTreeAllSelect = false
            } else {
                API.clientRoles.queryPbcTopicPermission(params).then((res) => {
                    if (res.code == '1') {
                        this.getTopicList(res.data.topicList)
                        /*this.filterValue = this.topicListFilter[0].id*/
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            }
        },
        getCheckedTreeList(arr) {
            if (arr instanceof Array) {
                const list = []
                arr.forEach((i, n) => {
                    list.push(i.id)
                })
                return list
            }
        },
        LinkageOther() {
            const list = this.getCheckedTreeList(this.$refs.tree.getCheckedNodes())
            if (list.length <= 0) {
                this.pbcFinalForm.final = this.pbcInterimForm.Interim = []
                this.categoryData = []
            } else {
                const params = {
                    roleId: this.roleId,
                    entityIds: list,
                    lang: this.$i18n.locale,
                    siteId: this.getSite.siteId,
                }
                this.getCategoryList(list, this.roleId)
                API.clientRoles.queryPbcPermission(params).then((res) => {
                    if (res.code == '1') {
                        const hasData = Array.isArray(this.pbcFinalForm.final)
                        this.pbcFinalForm.final = res.data.pbcGroupFinalList.map((item) => {
                            if (this.pbcFinalForm.final.some((prevItem) => prevItem.id == item.id && prevItem.checked)) {
                                return {
                                    ...item,
                                    checked: true
                                }
                            }
                            return item
                        })
                        const hasInterimData = Array.isArray(this.pbcInterimForm.Interim)
                        this.pbcInterimForm.Interim = res.data.pbcGroupInterimList.map((item) => {
                            if (
                                hasInterimData &&
                                this.pbcInterimForm.Interim.some((prevItem) => prevItem.id == item.id && prevItem.checked)
                            ) {
                                return {
                                    ...item,
                                    checked: true
                                }
                            }
                            return item
                        })
                        this.checkBoxPbc()
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            }
        },
        handleCheckChange(data) {
            data.checked = !data.checked
            this.switchFlag = this.switchFlag === 0 ? 1 : 0
            this.setStep()
            this.$nextTick(() => {
                this.LinkageOther()
            })
        },
        getMenuListChecked() {
            const list = []
            this.titleForm.configList.forEach((i, n) => {
                if (i.checked ) { //|| i.menuCode === 'client006'
                    list.push({ menuId: i.menuId })
                }
            })
            return list
        },
        getCheckedTopicList() {
            let topList = []
            this.topicListFilter.forEach((i, n) => {
                // let Okey = 'topicTree' + n
                const treeData = this.topicList.get(i.id)
                const selectKeyList = this.topicTreeCheckedList.get(i.id) || []
                const stack = [...treeData]
                while (stack.length) {
                    const node = stack.pop()
                    if (node.childTopic) stack.push(...node.childTopic)
                    if (selectKeyList.includes(node.topicBindId)) topList.push({p_id: i.id, ...node})
                }
            })
            return topList
        },
        onConfirm() {
            this.$refs.ruleForm.validate((validate) => {
                if (validate) {
                    if (this.getMenuListChecked().length <= 0 || this.getCheckedTreeList(this.$refs.tree.getCheckedNodes()).length <= 0) {
                        this.$message.error(this.$t('CLIENT_ROLE_ENTITY_OR_TILES'))
                    } else {
                        /**
                              20230725 更新
                              因为增加了ITU模块，将上面的B拆分为没有勾选PBC清单和没有勾选携手共享文件夹两种情况，
                              并且增加了ITU的判断。旧的wording请查看0725之前的gitlog

                              1. 如果勾选了携手共享板块，但没有勾选任何文件夹，也没有勾选ITU，则提示：
                                 请勾选“携手共享“版块中的具体内容，以实现有效授权！
                                 Please select the folder(s) in Joint Working tile to authorise access!
                              2. 如果勾选了PBC模块，但没勾选清单，则提示：
                                 请勾选PBC清单，以实现有效授权！
                                 Please select the PBC list(s) to authorise access!
                              3. 如果勾选了PBC模块，但没有PBC清单，则提示:
                                 未检测到与勾选的客户实体相关的PBC清单。请创建好PBC清单后再配置客户角色，以实现有效授权！
                                 No PBC list found of the selected entities. Please first set up the PBC list(s) in PBC tile before the client roles configuration and authorization!
                          */
                        let messageList = []
                        if (this.titleForm.configList.find((v) => v.menuId == '14' && v.checked)) {
                            if ([...this.pbcFinalForm.final, ...this.pbcInterimForm.Interim].length == 0) {
                                messageList.push(this.$t('client_role_setting_guidance_A'))
                            }
                            if ([...this.pbcFinalForm.final, ...this.pbcInterimForm.Interim].filter((v) => v.checked).length == 0&&[...this.pbcFinalForm.final, ...this.pbcInterimForm.Interim].length>0) {
                                messageList.push(this.$t('client_role_setting_guidance_B'))
                            }
                            const getCheckedTopicList = this.getCheckedTopicList()
                            // if (!getCheckedTopicList || getCheckedTopicList.length == 0) {
                            //     messageList.push(this.$t('client_role_setting_guidance_C'))
                            // }
                             
                            if ([...this.pbcFinalForm.final, ...this.pbcInterimForm.Interim].filter(v => v.checked).some(v => {
                                //  
                                const findChild = getCheckedTopicList.find(vv => vv.p_id == v.id)
                                //  
                                if (!findChild) {
                                    this.filterValue = v.id
                                    return true
                                } else {
                                    return false
                                }
                            })) {
                                messageList.push(this.$t('client_role_setting_guidance_C'))
                            }

                        }
                        if (this.titleForm.configList.find((v) => v.menuId == '20' && v.checked)) {
                            if (this.categoryData.filter((v) => v.checked).length == 0 && this.ituChecked !== '1') {
                                messageList.push(this.$t('client_role_setting_exchange_empty'))
                            }
                        }
                        if(this.adminShow&&this.adminTabs.filter((v) => v.checked).length<1){
                            messageList.push(this.$t('client_role_setting_admin_empty'))
                        }
                        
                        if (messageList.length > 0) {
                            this.$message({
                                message: messageList.join('<br/>'),
                                type: 'error',
                                dangerouslyUseHTMLString: true
                            })
                            return
                        }
                        this.getCheckedCatgeory()
                       
                        
                        this.onAdd({
                            roleId: this.roleId,
                            base: this.ruleForm,
                            entityIdList: this.getCheckedTreeList(this.$refs.tree.getCheckedNodes()),
                            menuList: this.getMenuListChecked(),
                            topicList: this.getCheckedTopicList(),
                            categoryList: this.categoryCheckedList,
                            roleItu: this.ituChecked,
                            adminList:this.adminTabs.filter((v) => v.checked).map(item=>item.key)
                        })
                    }
                }
            })
        },
        getEntityTreeDefaultChecked(node) {
            node.forEach((i, n) => {
                if (i.checked) {
                    this.entityTreeCheckedList.push(i.key)
                    this.entityTreeCheckedIds.push(i.id)
                }
                if (i.childEntity && i.childEntity.length > 0) {
                    this.getEntityTreeDefaultChecked(i.childEntity)
                }
            })
        },
        eachMap() {
            this.topicTreeCheckedList.clear()
            this.topicList.forEach((i, n) => {
                this.topicTreeCheckedListItem = []
                this.getTopicTreeDefaultChecked(i, n)
                this.topicTreeCheckedList.set(n, this.topicTreeCheckedListItem)
            })
        },
        getTopicTreeDefaultChecked(node, mKey) {
            node.forEach((i, n) => {
                if (i.checked) {
                    this.topicTreeCheckedListItem.push(i.topicBindId)
                }
                if (i.childTopic !== null && i.childTopic.length > 0) {
                    this.getTopicTreeDefaultChecked(i.childTopic, mKey)
                }
            })
        },
        dateFormat(value) {
            return dateFormat(new Date(value), 'yyyy-MM-dd')
        },
        async getCategoryList(entityList, roleId) {
            this.categoryLoading = true
            const params = {
                entityIdList: entityList,
                roleId: roleId,
                siteId: this.getSite.siteId
            }
            const { code, data } = await API.clientRoles.updateCtategory(params)
            if (code == '1') {
                this.categoryData = data
            } else {
                this.$message.error(this.$t(code))
            }
            this.categoryLoading = false
        },
        getCheckedCatgeory() {
            this.categoryCheckedList = []
            this.categoryData.forEach((item) => {
                if (item.checked) {
                    this.categoryCheckedList.push(item.category)
                }
            })
        }
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val)
        },
        topicTreeData() {
            if (!this.topicTreeData.length || !this.hasPbc) return
            const treeIdx = this.topicListFilter.findIndex((item) => {
                return item.id === this.filterValue
            })
            const stack = [...this.topicTreeData]
            this.$nextTick(() => {
                const TreeRef = this.$refs[`topicTree${treeIdx}`][0]
                const checkedKeys = TreeRef.getCheckedKeys()
                let flag = true
                while (stack.length) {
                    const data = stack.pop()
                    if (data.childTopic) {
                        data.childTopic.forEach((item) => {
                            stack.push(item)
                        })
                    }
                    if (!checkedKeys.includes(data.topicBindId)) {
                        flag = false
                    }
                }
                this.isTopicTreeAllSelect = flag
            })
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite'
        }),
        rules() {
            const rules = {
                roleName: [
                    { required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' },
                    {
                        pattern: UserInput.reg,
                        trigger: 'blur',
                        message: this.$t('ILLEGAL_USER_INPUT_01')
                    }
                ],
                description: [
                    {
                        pattern: UserInput.reg1,
                        trigger: 'blur',
                        message: this.$t('ILLEGAL_USER_INPUT_02')
                    }
                ]
            }
            return rules
        },
        topicTreeData() {
            return this.topicList.get(this.filterValue) || []
        },
        renderContent() {
            // 監聽改變
            this.switchFlag
            return (h, { node, data, store }) => {
                let isSelectAll = false
                let allNodes = []
                const showControlTag = Array.isArray(data.childEntity) && data.childEntity.length > 0
                if (showControlTag) {
                    ;[isSelectAll, allNodes] = this.isAllSelected(data)
                }
                return (
                    <span class="custom-tree-node">
                        <span>{node.label}</span>
                        {showControlTag && (
                            <span class="add-icon" onClick={() => this.switchSelect(isSelectAll, allNodes)}>
                                {isSelectAll ? this.$t('unselect_all') : this.$t('select_all')}
                            </span>
                        )}
                    </span>
                )
            }
        },
        hasPbc(){
            const rs = this.titleForm.configList.filter(item => item.menuCode === 'client001')
            return rs.length>0&&rs[0].checked
        }
    },
    async mounted() {
        this.pbcType = this.getSite.hasInterim ? 'Interim' : 'Final'
        
        if (this.initData) {
            this.data = [this.initData.entityTreeList]
            this.getEntityTreeDefaultChecked(this.data)
            this.titleForm.configList = this.initData.menuList
            this.pbcFinalForm.final = this.initData.pbcGroupFinalList
            this.pbcInterimForm.Interim = this.initData.pbcGroupInterimList
            const inteimOb = this.getCheckedPbcListName(this.initData.pbcGroupInterimList, 'Interim')
            const finalOb = this.getCheckedPbcListName(this.initData.pbcGroupFinalList, 'Final')
            this.topicListFilter = inteimOb.concat(finalOb)
            ;(this.filterValue = this.topicListFilter.length > 0 ? this.topicListFilter[0].id : ''),
                this.getTopicList(this.initData.topicList)
            this.eachMap()
            this.ruleForm.roleName = this.initData.row.roleName
            this.ruleForm.description = this.initData.row.roleDesc
            this.roleId = this.initData.row.roleId
            if (this.initData.row.roleId) {
                const list = this.entityTreeCheckedIds
                this.getCategoryList(list, this.roleId)
            }

            const tileList = this.getMenuListChecked()
            if (tileList.length > 0) {
                tileList.forEach((item) => {
                    if (item.menuId == 14) {
                        this.pbcShow = true
                    }
                    if (item.menuId == 20) {
                        this.categoryShow = true
                    }
                })
                this.activeStep = 2
            }
            if (this.topicListFilter.length > 0) {
                this.activeStep = 3

                if (this.topicTreeCheckedList.size > 0) {
                    let isChoose = false
                    for (let i = 0; i < this.topicListFilter.length; i++) {
                        let len = this.topicTreeCheckedList.get(this.topicListFilter[i].id)
                            ? this.topicTreeCheckedList.get(this.topicListFilter[i].id).length
                            : 0
                        if (len > 0) {
                            isChoose = true
                            break
                        }
                    }
                    if (isChoose) this.activeStep = 4
                }
            }
            if (this.initData.row.roleId === '') {
                this.titleForm.configList.map((configItem) => {
                    if (configItem.menuCode === 'client004') {
                        configItem.checked = true
                    }
                })    
            }
            //admin板块的编辑回显
            const adminMenu = this.initData.menuList.filter(menu=>menu.menuCode === 'client008')
            if(adminMenu.length>0&&adminMenu[0].checked){
                this.checkedAdminTab(false)
                const {code,data} =  await API.clientRoles.queryAdminPermission({
                    roleIdList: [this.roleId],
                    siteId: this.getSite.siteId
                })
                if(code === '1'){
                    const { contractStatus,feeAgreementStatus,invoiceStatus,vatInformationStatus, showVatInformation } = data;
                    const userAdminStatus = {
                        adminContract:contractStatus === 'Y',
                        adminFeeAgreement:feeAgreementStatus === 'Y',
                        adminVatInformation:vatInformationStatus === 'Y',
                        adminInvoice:invoiceStatus === 'Y'
                    }
                    this.adminTabs.forEach(adminTab=>{
                        adminTab.checked = userAdminStatus[adminTab.key]
                        if(adminTab.key === 'adminVatInformation'){
                            adminTab.disabled = !showVatInformation;
                        }
                    })

                }
                 
            }

            
            
            this.ituChecked = this.initData.row.roleItu
        }

        this.queryShowVatInformation()
    },
    props: {
        onAdd: Function,
        onCancel: Function,
        saveLoading: Boolean,
        initData: [String, Object]
    }
}
</script>

<style>
.role-tip{
    font-weight: normal;
    font-size: 12px;
}
.with-select-all-tree-clientRoles .custom-tree-node {
    display: inline-block;
    width: 100%;
    padding-right: 10px;
}

.with-select-all-tree-clientRoles .custom-tree-node .add-icon {
    float: right;
    color: #1e49e2;
}
.step-content .el-checkbox__input.is-checked .el-checkbox__inner,
.step-content .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #1e49e2;
    border-color: #1e49e2;
}
.step-content .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #1e49e2;
}
.step-content .title-form-item .el-checkbox__input.is-disabled.is-checked + .el-checkbox__label {
    color: #c0c4cc;
}
.step-content .title-form-item .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #f2f6fc;
    border-color: #dcdfe6;
}

.with-select-all-tree-clientRoles .el-tree {
    width: 100%;
}
</style>
<style scoped>
.roleAdd_moda ::v-deep .el-dialog .el-dialog__body {
    padding-top: 0;
}
.label-cls {
    margin-left: 5px;
}
.step {
    min-height: 37vh;
    max-height: 50vh;
    overflow: auto;
}
.step ::v-deep .el-steps .step-des .el-step__title {
    /* font-size: 12px; */
    line-height: 20px;
    color: #a9acaf;
    font-weight: normal;
}
.step ::v-deep .el-steps .step-des .el-step__title.is-success,
.step ::v-deep .el-steps .step-des .el-step__title.is-process {
    color: #1e49e2;
}
.step ::v-deep .el-steps .step-des .el-step__head .el-step__icon.is-text {
    color: #ccced2;
    border: 1px solid #ccced2;
    border-radius: 50%;
}
.step ::v-deep .el-steps .step-des .el-step__head.is-success .el-step__icon,
.step ::v-deep .el-steps .step-des .el-step__head.is-process .el-step__icon {
    background-color: #1e49e2;
    color: #fff;
    border-width: 0;
}
.step ::v-deep .el-steps .step-des .el-step__head.is-success {
    border-color: #c0c4cc;
}
.step-content {
    margin-top: 10px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    /* font-size: 12px; */
}
.part-entity {
    width: 24%;
    margin-right: 10px;
}
.part-tile {
    width: 24%;
    margin-right: 10px;
}
.part-pbcOrCategory {
    width: 24%;
    margin-right: 10px;
}
.part-detailPbc {
    width: 26%;
}
.fourth-box-select {
    color: #1e49e2;
    cursor: pointer;
    position: absolute;
    right: 28px;
    top: 5px;
    z-index: 1111;
}
.pbc-select-item.selected {
    color: #1e49e2;
}
.title {
    font-weight: 700;
    font-style: normal;
    font-size: 13px;
    color: #555555;
    padding: 5px 0;
}

.box-item {
    border: 1px solid #cccccc;
}

.item-title {
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    background-color: #f3f7ff;
    font-weight: 700;
    /* font-size: 12px; */
    font-style: normal;
}
.category-title {
    width: calc(100% - 75px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.item-content {
    width: 100%;
    height: 240px;
    overflow-y: auto;
    position: relative;
}

.item-content >>> .el-tree-node__content > label.el-checkbox {
    margin-right: 8px;
}

.title-select-content {
    display: flex;
    justify-content: space-between;
    padding-right: 10px;
}

.select-cls {
    color: #1e49e2;
    /* font-size: 12px; */
    font-weight: normal;
    cursor: pointer;
    min-width: 75px;
}

.titleForm,
.pbcInterimForm,
.pbcFinalForm {
    padding: 0 10px;
}
.title-form-item ::v-deep .el-checkbox .el-checkbox__label,
.categoryItem ::v-deep .el-checkbox .el-checkbox__label {
    font-size: 12PX;
}

.item-collapse {
    position: relative;
}

.pbc-selectAll-cls {
    position: absolute;
    right: 10px;
    top: 5px;
}

.change-btn {
    display: block;
    float: right;
    margin-right: 8px;
    cursor: pointer;
}

.change-btn:hover {
    color: #0091da;
}

.change-btn-active {
    color: #0091da;
}

.topFilter {
    float: left;
    width: 100%;
}

.entity:before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
}

.moda-title {
    font-size: 18px;
    padding: 0 20px 0 5px;
}

.tip {
    font-size: 12px;
    color: #606266;
    font-weight: 400;
}
.categoryItem {
    height: 26px;
    line-height: 26px;
}
.demo-ruleForm {
    margin-top: 10px;
}
/*pbc list item 超长省略显示---------start---------*/
.part-detailPbc ::v-deep .el-tree .el-tree-node {
    width: 100%;
}
.part-detailPbc ::v-deep .el-tree .el-tree-node:nth-child(1) {
    width: 80%;
}
.part-detailPbc ::v-deep .el-tree .el-tree-node .tree-node {
    display: inline-block;
    width: 100%;
}
.part-detailPbc ::v-deep .el-tree .el-tree-node:nth-child(1) .tree-node {
    display: inline-block;
    width: 74%;
}
.part-detailPbc .tree-label-cls {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 80%;
    display: inline-block;
}
/*pbc list item 超长省略显示---------end---------*/
::v-deep .el-collapse-item__header, ::v-deep .blod,
::v-deep .el-collapse-item__header:hover {
    font-weight: 600;
    color: #606266;
    font-size: 12PX;
}
.itu-checkbox .el-checkbox__label{
    padding: 0;
    margin-left: 7PX;
}

::v-deep .set-disabled .el-checkbox__input.is-disabled.is-checked + .el-checkbox__label {
    color: #1e49e2 !important;
}

::v-deep .set-disabled .el-checkbox__input.is-checked .el-checkbox__inner, .step-content .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #1e49e2 !important;
    border-color: #1e49e2 !important;
}

::v-deep .set-disabled .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #fff;
}
</style>
